import { useState } from "react"
import { useUser } from "@/api/users"
import { Button } from "@/components/ui/button"
import { ReceiveModal } from "./receive.modal"
import ArrowDownIcon from "@/components/icons/arrow-down"
// KYC gating removed – receive flow accessible post-onboarding wallet.

interface ReceiveButtonProps {
  variant?: "default" | "outline";
}

export default function ReceiveButton({
  variant = "default",
}: ReceiveButtonProps) {
  const { user } = useUser()
  const [isOpen, setIsOpen] = useState(false)

  if (!user) return null

  const handleClick = () => setIsOpen(true)

  return (
    <>
      {user.hasWallet && (
        <ReceiveModal open={isOpen} onOpenChange={setIsOpen} />
      )}
      <Button
        variant={variant}
        onClick={handleClick}
        data-testid="withdraw"
        disabled={!user.hasWallet}
        className="flex-grow"
      >
        <ArrowDownIcon direction="down" />
        Receive
      </Button>
    </>
  )
}
